export default (state = {}, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {};
    case 'LOGOUT':
      return {};
    case 'RESETDADOSALL':
      return {};
    case 'RESETDADOPESQ':
      if (!!action.nome && typeof (action.nome) === "string")
        state[action.nome.toLowerCase()] = undefined;

      return state;
    case 'SETDADOSPESQ':
      return { ...state, [action.name]: action.dados };
    default:
      return state;
  }
};